import APIService from './APIService'
import axios from 'axios'

/**
 * Class PublicationService
 * Represents Publications services in the api
 * Note: Requires the authentication header in axios
 * */
export default class PublicationService extends APIService{

    constructor(){
        super()
    }

    /**
     * Sends publish request
     * Params:
     *  data: A JSON array required by the api for publish a new publication
     * */
    static publish(data){
        return axios.post( APIService.API_URL + '/publication/' + data.type, data)
    }
}
